module.exports = __webpack_public_path__ + "static/media/bball-trivia.9b83cbb4.png";